export default class SignupController {
  constructor(CurrentUser, CurrentAccount, $location, $window, $timeout,
    AnalyticsServ) {
    this.analyticsServ = AnalyticsServ;
    this.location = $location;
    this.window = $window;
    this.user = CurrentUser;
    this.account = CurrentAccount;
    this.timeout = $timeout;
    this.setAccountName = false;

    this.variant = $location.search().variant;
    this.lexicon = $location.search().lexicon;

    var referrerCode = $location.search().referrer;
    if (typeof referrerCode === 'string') {
      // lookup referrer info and set data
      this.user.api.queryInviter({ id: referrerCode }).then(referrer => {
        this.referrer = referrer;
      });
    }
    this.user.setData({});
    document.querySelectorAll('[name="firstName"]')[0].focus()
  }
  redirectHome() {
    this.window.location.href = '/app/#' + this.location.url('/home').url();
    this.window.location.reload();
  }
  signup() {
    if (this.lexicon) {
      this.user.data.lexicon = this.lexicon;
    }
    this.user.api.signup().then(data => {

      this.account.api.get().then(() => {
        if (!this.account.data.displayName) {
          this.setAccountName = true;
          this.timeout(() => {
            document.querySelectorAll('[name="firm-name"]')[0].focus()
          }, 0, false);
        } else {
          this.redirectHome()

        }
      })

      this.analyticsServ.setUser({
        id: data.id,
        'Referred By': this.referrer && this.referrer.email,
        'Variant': this.variant || 'default'
      })

    });
  }
  nameAccount() {
    this.account.api.update().then(() => {
      this.redirectHome();
    })
  }
}
SignupController.$inject = ['CurrentUser', 'CurrentAccount', '$location',
  '$window', '$timeout', 'AnalyticsServ'
];



// WEBPACK FOOTER //
// ./project/pages/signup/signup.controller.js